import { readMasterTick, tickToProps } from '../../../DocEditor/utils/tickOverrides';
import { mapBlocksInTableData } from '../../../DocEditor/utils/tableCellBlocks';

/** Walk the tree and set each checkbox's tick from the map (when present). */
export const setChecksFromMap = (tree, checkedById) =>
  tree.map((block) => {
    let next = block;
    if (block.type === 'checkbox' && checkedById.has(block.id)) {
      const target = checkedById.get(block.id);
      if (readMasterTick(block) !== target) {
        next = { ...block, props: { ...block.props, ...tickToProps(target) } };
      }
    }
    if (next.children?.length) {
      const children = setChecksFromMap(next.children, checkedById);
      if (children.some((c, i) => c !== next.children[i])) {
        next = next === block ? { ...block, children } : { ...next, children };
      }
    }
    if (next.type === 'table' && next.props?.tableData) {
      const mapped = mapBlocksInTableData(next.props.tableData, (cell) =>
        setChecksFromMap(cell, checkedById)
      );
      if (mapped.changed) {
        next = {
          ...next,
          props: { ...next.props, tableData: mapped.tableData },
        };
      }
    }
    return next;
  });

/** Record every checkbox's current tick as the known master default. */
export const collectTicks = (tree, into = new Map()) => {
  for (const block of tree || []) {
    if (block.type === 'checkbox') into.set(block.id, readMasterTick(block));
    if (block.children?.length) collectTicks(block.children, into);
    if (block.type === 'table' && block.props?.tableData) {
      const cells = [
        ...(block.props.tableData.headers || []),
        ...(block.props.tableData.rows || []).flat(),
      ];
      for (const cell of cells) {
        if (Array.isArray(cell)) collectTicks(cell, into);
      }
    }
  }
  return into;
};
